import DatePicker from 'react-datepicker';
import moment from 'moment/moment';
import CustomCalendarHeader from '../../../../DateInput/CalendarInput/CustomCalendarHeader';
import React, { useCallback } from 'react';
import { CalendarWrapper } from '../../../../DateInput/CalendarInput/CalendarInput';

const PeriodRefiner = ({
  maxDate,
  minDate,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}: {
  maxDate: string;
  minDate: string;
  startDate: string;
  endDate: string;
  setStartDate: React.Dispatch<React.SetStateAction<string>>;
  setEndDate: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [currentlySelecting, setCurrentlySelecting] =
    React.useState<string>('startDate');

  const onCalendarDateChange = useCallback(
    (newDate: Date, event: React.SyntheticEvent<any, Event> | undefined) => {
      const newDateIso = moment(newDate.toDateString()).format('YYYY-MM-DD');

      if (currentlySelecting === 'startDate') {
        setStartDate(newDateIso);
      } else {
        setEndDate(newDateIso);
      }
      setCurrentlySelecting(
        currentlySelecting === 'startDate' ? 'endDate' : 'startDate',
      );
    },
    [currentlySelecting, setEndDate, setStartDate],
  );

  return (
    <CalendarWrapper id={'calendar'}>
      <DatePicker
        calendarClassName={'fleetops-calendar'}
        selected={
          currentlySelecting === 'startDate'
            ? moment(startDate).toDate()
            : moment(endDate).toDate()
        }
        renderCustomHeader={CustomCalendarHeader}
        startDate={moment(startDate).toDate()}
        endDate={moment(endDate).toDate()}
        maxDate={moment(maxDate).toDate()}
        minDate={moment(minDate).toDate()}
        onSelect={onCalendarDateChange}
        onChange={() => {}}
        disabledKeyboardNavigation
        inline
      />
    </CalendarWrapper>
  );
};

export default PeriodRefiner;
